import React from 'react'
import './assets/css/style.css'
import './assets/vendor/bootstrap/css/bootstrap.min.css'
import './assets/vendor/icofont/icofont.min.css'
import './assets/vendor/boxicons/css/boxicons.min.css'
import './assets/vendor/venobox/venobox.css'
import './assets/vendor/owl.carousel/assets/owl.carousel.min.css'


function Main() {
  return (
    <div>
         <div>
        {/* ======= Header ======= */}
        <header id="header" className="fixed-top">
          <div className="container-fluid d-flex">
            <div className="logo mr-auto ">
              <h1 className="text-light "><a href="index.html"><span>Vidriera Emprendedora Virtual</span></a></h1>
              {/* Uncomment below if you prefer to use an image logo */}
              {/* <a href="index.html"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>*/}
            </div>
            <nav className="nav-menu d-none d-lg-block">
              <ul>
                <li className="active"><a href="#header">Inicio</a></li>
                <li><a href="#about">Sobre Nosotros</a></li>
                <li><a href="#services">Servicios</a></li>
                <li><a href="#portfolio">Emprendedoras</a></li>
                <li className="get-started"><a href="#contact">Contactanos</a></li>
              </ul>
            </nav>{/* .nav-menu */}
          </div>
        </header>{/* End Header */}
        {/* ======= Hero Section ======= */}
        <section id="hero" className="d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1">
                <h1>Potenciamos, capacitamos y acompañamos emprendedoras.</h1>
                <a href="#contact" className="btn-get-started scrollto ">Contactanos!</a>
              </div>
              <div className="col-lg-6 order-1 order-lg-2 hero-img">
                <img src={require('./assets/img/wfh_8.svg')} className="img-fluid animated" alt="" />
              </div>
            </div>
          </div>
        </section>{/* End Hero */}
        <main id="main">
          {/* ======= About Section ======= */}
          <section id="about" className="about">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-lg-5 d-flex align-items-center justify-content-center about-img">
                  <img src={require('./assets/img/about-img.svg')} className="img-fluid" alt="" data-aos="zoom-in" />
                </div>
                <div className="col-lg-6 pt-5 pt-lg-0 mt-5">
                  <h3 data-aos="fade-up">¡Hola Mujeres Emprendedoras!</h3>
                  <p data-aos="fade-up" data-aos-delay={100}>
                  
                      Les presentamos nuestra VIDRIERA EMPRENDEDORA VIRTUAL, donde compartimos algunos emprendimientos de las participantes del curso <b>Acompañando a Mujeres Emprendedoras</b>, Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM, organizado por Red Proter y Mujeres Emprendedoras MDP.
                  </p>
                </div>
              </div>
            </div>
          </section>{/* End About Section */}
          {/* ======= Services Section ======= */}
          <section id="services" className="services section-bg">
            <div className="container">
              <div className="section-title" data-aos="fade-up">
                
                <p>¿Qué le ofrecemos a las emprendedoras?</p>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay={100}>
                  <div className="icon-box">
                    <div className="icon"><i class='bx bx-user-circle'></i></div>
                    <h4 className="title"><a href>Acompañamiento</a></h4>
                    <p className="description"> Acompañamos a las mujeres en sus trayectorias laboriales</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay={200}>
                  <div className="icon-box">
                    <div className="icon"><i className="bx bx-file" /></div>
                    <h4 className="title"><a href>Capacitación</a></h4>
                    <p className="description">Capacitamos en nuestra plataforma educativa para un mayor desarrollo de sus productos.</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay={300}>
                  <div className="icon-box">
                    <div className="icon"><i className="bx bx-tachometer" /></div>
                    <h4 className="title"><a href>Potenciamiento</a></h4>
                    <p className="description">Potenciamos sus emprendimientos para fortalecerlos y darlos a conocer.</p>
                  </div>
                </div>
                
              </div>
            </div>
          </section>{/* End Services Section */}
          {/* ======= Portfolio Section ======= */}
          <section id="portfolio" className="portfolio">
            <div className="container">
              <div className="section-title" data-aos="fade-up">
                
                <p>Conocé a las emprendedoras</p>
              </div>
             {/*} <div className="row" data-aos="fade-up" data-aos-delay={100}>
                <div className="col-lg-12">
                  <ul id="portfolio-flters">
                    <li data-filter="*" className="filter-active">All</li>
                    <li data-filter=".filter-app">App</li>
                    <li data-filter=".filter-card">Card</li>
                    <li data-filter=".filter-web">Web</li>
                  </ul>
                </div>
  </div>*/}

              
              <div className="row portfolio-container" data-aos="fade-up" data-aos-delay={200}>

              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/Decorati/Decorati.jpeg")} className="img-fluid"  alt="Decorati Decoración" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://wa.me/5492392627816" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Decorati/Decorati.jpeg")} data-gall="Decorati" className="venobox" title="Decorati Decoración"></a>
                      <a href={require("./assets/img/portfolio/Decorati/Decorati2.jpeg")} data-gall="Decorati" className="venobox" title="Decorati Decoración"></a>
                      <a href={require("./assets/img/portfolio/Decorati/Decorati3.jpeg")} data-gall="Decorati" className="venobox" title="Decorati Decoración" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Decorati Decoración</h4>
    
                    </div>
                  </div>
                </div>
                
              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/AmeliTeje/AmeliTeje.jpeg")} className="img-fluid"  alt="Decorati Decoración" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/ameli.teje" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/ameli_teje/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235276995" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/AmeliTeje/AmeliTeje.jpeg")} data-gall="ameliteje" className="venobox" title="Ameli Teje"></a>
                      <a href={require("./assets/img/portfolio/AmeliTeje/AmeliTeje2.jpeg")} data-gall="ameliteje" className="venobox" title="Ameli Teje"></a>
                      <a href={require("./assets/img/portfolio/AmeliTeje/AmeliTeje3.jpeg")} data-gall="ameliteje" className="venobox" title="Ameli Teje" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Ameli Teje</h4>
    
                    </div>
                  </div>
                </div>

              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/AromasDelViento/Aromas.jpeg")} className="img-fluid"  alt="Aromas del Alma" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/Aromas-Del-Alma-195316071113216" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/aromasdelalma_mdp/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492236162276" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/AromasDelViento/Aromas.jpeg")} data-gall="aromasdelalma" className="venobox" title="Aromas del Alma"></a>
                      <a href={require("./assets/img/portfolio/AromasDelViento/Aromas1.jpeg")} data-gall="aromasdelalma" className="venobox" title="Aromas del Alma"></a>
                      <a href={require("./assets/img/portfolio/AromasDelViento/Aromas2.jpeg")} data-gall="aromasdelalma" className="venobox" title="Aromas del Alma" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Aromas del Alma.</h4>
    
                    </div>
                  </div>
                </div>

                



              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/TahielMacrame/Tahiel.jpeg")} className="img-fluid"  alt="Tahiel" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/Hilosypiedras" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/anitahielmacrame/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492236637406" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/TahielMacrame/Tahiel.jpeg")} data-gall="tahiel" className="venobox" title="Tahiel Macrame"></a>
                      <a href={require("./assets/img/portfolio/TahielMacrame/Tahiel1.jpeg")} data-gall="tahiel" className="venobox" title="Tahiel Macrame"></a>
                      <a href={require("./assets/img/portfolio/TahielMacrame/Tahiel2.jpeg")} data-gall="tahiel" className="venobox" title="Tahiel Macrame" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Tahiel Macrame.</h4>
                    </div>
                  </div>
                </div>



              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/Lanogui/Lanogui2.jpeg")} className="img-fluid"  alt="Lanogui" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/lanoguimdp" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/lanoguimdp/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235697084" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Lanogui/Lanogui.jpeg")} data-gall="lanogui" className="venobox" title="Lanogui"></a>
                      <a href={require("./assets/img/portfolio/Lanogui/Lanogui1.jpeg")} data-gall="lanogui" className="venobox" title="Lanogui"></a>
                      <a href={require("./assets/img/portfolio/Lanogui/Lanogui2.jpeg")} data-gall="lanogui" className="venobox" title="Lanogui" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Lanogui.</h4>
    
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/TresDeseos/TresDeseos.jpeg")} className="img-fluid"  alt="Tres Deseos Deco." />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/3deseosmdp" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/tresdeseosdecomdp/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235357189" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/TresDeseos/TresDeseos.jpeg")} data-gall="tresdeseos" className="venobox" title="Tres Deseos"></a>
                      <a href={require("./assets/img/portfolio/TresDeseos/TresDeseos1.jpeg")} data-gall="tresdeseos" className="venobox" title="Tres Deseos"></a>
                      <a href={require("./assets/img/portfolio/TresDeseos/TresDeseos2.jpeg")} data-gall="tresdeseos" className="venobox" title="Tres Deseos" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Tres Deseos Deco</h4>
    
                    </div>
                  </div>
                </div>
              <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/VelasEnElMar/vMar.jpeg")} className="img-fluid"  alt="Velas en el Mar." />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/velasenelmar" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/velas_en_el_mar/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492234246408" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/VelasEnElMar/vMar.jpeg")} data-gall="velasenelmar" className="venobox" title="Velas en el Mar."></a>
                      <a href={require("./assets/img/portfolio/VelasEnElMar/vMar1.jpeg")} data-gall="velasenelmar" className="venobox" title="Velas en el Mar."></a>
                      <a href={require("./assets/img/portfolio/VelasEnElMar/vMar2.jpeg")} data-gall="velasenelmar" className="venobox" title="Velas en el Mar." ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Velas en el Mar, velas artesanales.</h4>
    
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/Destellos/Destellos.jpeg")} className="img-fluid"  alt="Destellos, " />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/destellos_luz_de_luna-103163671117110" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/destellos_luz_de_luna/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235747268" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Destellos/Destellos.jpeg")} data-gall="destellos" className="venobox" title="Destellos"></a>
                      <a href={require("./assets/img/portfolio/Destellos/Destellos1.jpeg")} data-gall="destellos" className="venobox" title="Destellos"></a>
                      <a href={require("./assets/img/portfolio/Destellos/Destellos2.jpeg")} data-gall="destellos" className="venobox" title="Destellos" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Destellos</h4>
    
                    </div>
                  </div>
                </div>


                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/Kanela/Kanela1.jpeg")} className="img-fluid"  alt="Kanela, Cosmética Natural" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/Kanela.CosmeticaNaturalMDP"  target="_blank"  title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/kanela.cosmetica/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235184800" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Kanela/Kanela1.jpeg")} data-gall="kanela" className="venobox" title="Kanela, Cosmética Natural"></a>
                      <a href={require("./assets/img/portfolio/Kanela/Kanela2.jpeg")} data-gall="kanela" className="venobox" title="Kanela, Cosmética Natural"></a>
                      <a href={require("./assets/img/portfolio/Kanela/Kanela3.jpeg")} data-gall="kanela" className="venobox" title="Kanela, Cosmética Natural" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Kanela, Cosmética Natural</h4>
    
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/BunVenit/BunVenit.jpeg")} className="img-fluid"  alt="Bun Venit, Accesorios para Bebés." />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/bunvenitbebes" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/bun_venit/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235903752" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/BunVenit/BunVenit.jpeg")} data-gall="bunvenit" className="venobox" title="Bun Venit, Accesorios para Bebés."></a>
                      <a href={require("./assets/img/portfolio/BunVenit/BunVenit2.jpeg")} data-gall="bunvenit" className="venobox" title="Bun Venit, Accesorios para Bebés."></a>
                      <a href={require("./assets/img/portfolio/BunVenit/BunVenit3.jpeg")} data-gall="bunvenit" className="venobox" title="Bun Venit, Accesorios para Bebés." ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Bun Venit, Accesorios para Bebés.</h4>
    
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/Panier/Panier.jpeg")} className="img-fluid"  alt="Oh La La Panier" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/ohlalapanier" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/ohlalapanier" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235062078" target="blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Panier/Panier.jpeg")} data-gall="laPanier" className="venobox" title="Oh La La Panier, canastas y cestos Artesanales"></a>
                      <a href={require("./assets/img/portfolio/Panier/Panier2.jpeg")} data-gall="laPanier" className="venobox" title="Oh La La Panier, canastas y cestos Artesanales"></a>
                      <a href={require("./assets/img/portfolio/Panier/Panier3.jpeg")} data-gall="laPanier" className="venobox" title="Oh La La Panier, canastas y cestos Artesanales" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Oh La La Panier, canastas y cestos Artesanales</h4>
    
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap" style={{height:'350px'}}>
                    <img src={require("./assets/img/portfolio/ArcoIris/ArcoIris.jpeg")} className="img-fluid"  alt="Arco Iris Tejidos" />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/Arco-Iris-Tejidos-123402609450758/" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/arcoiristejidos_69/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235206994" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/ArcoIris/ArcoIris.jpeg")} data-gall="arcoiris" className="venobox" title="Arco Iris Tejidos"></a>
                      <a href={require("./assets/img/portfolio/ArcoIris/ArcoIris2.jpeg")} data-gall="arcoiris" className="venobox" title="Arco Iris Tejidos"></a>
                      <a href={require("./assets/img/portfolio/ArcoIris/ArcoIris3.jpeg")} data-gall="arcoiris" className="venobox" title="Arco Iris Tejidos" ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Arco Iris Tejidos</h4>
    
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap">
                    <img src={require("./assets/img/portfolio/Calzados/Calzados.jpeg")} className="img-fluid"  alt="Eva Ylicich Calzados." />
                    <div className="portfolio-links">
                      <div className="mt-2">
                      <a href="https://www.facebook.com/calzadosevaylicichMR" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/evaylicich/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/542235025309" target="_blank" title="Whatsapp"><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Calzados/Calzados.jpeg")} data-gall="galleryCalzados" className="venobox" title="Eva Ylicich Calzados."></a>
                      <a href={require("./assets/img/portfolio/Calzados/Calzados1.jpeg")} data-gall="galleryCalzados" className="venobox" title="Eva Ylicich Calzados."></a>
                      <a href={require("./assets/img/portfolio/Calzados/Calzados2.jpeg")} data-gall="galleryCalzados" className="venobox" title="Eva Ylicich Calzados." ></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Eva Ylicich Calzados.</h4>
    
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap">
                    <img src={require("./assets/img/portfolio/Makia/Makia.jpeg")} className="img-fluid"  alt="Makia la Energía de lo Natural" />
                    <div className="portfolio-links">
                      
                      
                      <div className="mt-2">
                      <a href="https://www.facebook.com/Apicultura-Sustentable-105736207907216" target="_blank" title="Facebook"><i className="icofont-facebook" /></a>
                      <a href="https://www.instagram.com/makia.energia.natural/" target="_blank" title="Instagram"><i class="icofont-instagram"></i></a>
                      <a href="https://wa.me/5492235941328" target="_blank" title="Whatsapp" ><i class="icofont-brand-whatsapp"></i></a>
                      </div>
                      <div className="gallery">
                      <a href={require("./assets/img/portfolio/Makia/Makia.jpeg")}  infinigall="true" data-gall="portfolioGallery" className="venobox imglink" title="Makia la Energía de lo Natural"></a>
                      <a href={require("./assets/img/portfolio/Makia/Makia1.jpeg")} infinigall="true" data-gall="portfolioGallery" className="venobox imglink" title="Makia la Energía de lo Natural"></a>
                      <a href={require("./assets/img/portfolio/Makia/Makia2.jpeg")} infinigall="true" data-gall="portfolioGallery" className="venobox imglink" title="Makia la Energía de lo Natural"></a>
                      </div>
                    </div>
                    <div className="portfolio-info">
                      <h4>Makia la Energía de lo Natural</h4>
    
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
          </section>{/* End Portfolio Section */}
          {/* ======= Contact Us Section ======= */}
          <section id="contact" className="contact">
            <div className="container">
              
              <div className="section-title" data-aos="fade-up">
                
                <p>Contactanos para más información</p>
              </div>
              <div className="row">
                <div className="col-lg-7 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={100}>
                  <div className="info">
                    <div className="address">
                      <i className="icofont-google-map" />
                      <h4>Ubicación:</h4>
                      <p>San Luís 3010, Mar del Plata, Argentina</p>
                    </div>
                    <div className="email">
                      <i className="icofont-envelope" />
                      <h4>Email:</h4>
                      <p>info@proter.com.ar</p>
                    </div>
                    <div className="phone">
                      <i className="icofont-phone" />
                      <h4>Cel:</h4>
                      <p>+54 223 4955091</p>
                    </div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.610700980329!2d-57.55854218431352!3d-38.009539979717275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9584dea1009488c9%3A0xeae57d690afc1a83!2sSan+Luis+3010%2C+B7602BYF+Mar+del+Plata%2C+Buenos+Aires!5e0!3m2!1ses!2sar!4v1531612707164" style={{border: 0, width: '100%', height: '290px'}}  frameborder="0"></iframe>
                  
                  </div>
                </div>
                <div className="col-lg-5 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={200}>
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FRedProter%2F&tabs&width=340&height=214&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=809262689545894" width="340" height="214" style={{border:"none", overflow:"hidden"}} scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
                </div>
              </div>
            </div>
          </section>{/* End Contact Us Section */}
        </main>{/* End #main */}
        {/* ======= Footer ======= */}
        <footer id="footer">
          <div className="footer-newsletter" data-aos="fade-up">
            <div className="container-fluid">
              <div className="row ">
                  <div className="col-md-12">
                    <img className="img-fluid" src={require('./assets/img/banner.png')} alt="PROTER" ></img>
                  </div>
              </div>
            </div>
          </div>
          <div className="footer-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-6 footer-contact" data-aos="fade-up" data-aos-delay={100}>
                  <h3>Vidriera Emprendedora</h3>
                  <p>
                    San Luis 3010<br />
                    Mar del Plata, B7600<br />
                    Argentina <br /><br />
                    <strong>Cel:</strong> +54 223 4955091<br />
                    <strong>Email:</strong> info@proter.com.ar<br />
                  </p>
                </div>
                <div className="col-lg-4 col-md-6 footer-links" data-aos="fade-up" data-aos-delay={200}>
                  <h4>Links Útiles</h4>
                  <ul>
                    <li><i className="bx bx-chevron-right" /> <a href="/#header">Inicio</a></li>
                    <li><i className="bx bx-chevron-right" /> <a href="/#about">Sobre Nosotros</a></li>
                    <li><i className="bx bx-chevron-right" /> <a href="/#services">Services</a></li>
                    <li><i className="bx bx-chevron-right" /> <a href="/#portfolio">Emprendedoras</a></li>
                    <li><i className="bx bx-chevron-right" /> <a href="/#contact">Contactanos</a></li>
                    
                  </ul>
                </div>
          
                <div className="col-lg-4 col-md-6 footer-links" data-aos="fade-up" data-aos-delay={400}>
                  <h4>Nuestras Redes Sociales</h4>
                  
                  <div className="social-links mt-3">
                    <a href="https://www.facebook.com/RedProter/" taret="_blank" className="facebook"><i className="bx bxl-facebook" /></a>
                    <a href=" https://www.instagram.com/red.proter/" taret="_blank" className="facebook"><i className="bx bxl-instagram" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container py-4">
            <div className="copyright">
            Proyecto realizado en el marco del Programa de Fortalecimiento Institucional del ex-INAM.
            
            </div>
            <div className="credits">
            Organizado por Red Proter y Mujeres Emprendedoras MDP.
            </div>
          </div>
        </footer>{/* End Footer */}
        <a href="/#" className="back-to-top"><i className="icofont-simple-up" /></a>
        {/* Vendor JS Files */}
        {/* Template Main JS File */}
      </div>
 


      <script src="./vendor/jquery/jquery.min.js"></script>
      <script src="./vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="./vendor/jquery.easing/jquery.easing.min.js"></script>
      <script src="./vendor/php-email-form/validate.js"></script>
      <script src="./vendor/isotope-layout/isotope.pkgd.min.js"></script>
      <script src="./vendor/venobox/venobox.min.js"></script>
      <script src="./vendor/owl.carousel/owl.carousel.min.js"></script>
      <script src="./vendor/aos/aos.js"></script>
      <script src="./assets/js/main.js"></script>

    </div>
  )
}

export default Main
